import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllInterviews } from "../../../redux/actions";
import InterviewCard from "../../PostAJob/EmployerProfile/components/interviewCard/InterviewCard";
import Loader from "../../../components/Loading/Loader";
import EmptyInterviews from "../../../assets/img/EmptyInterviews1.png";
import "./InterviewListing.css";
import moment from "moment";
import { Row, Col } from "antd";

const InterviewListing = () => {
  const interviews = useSelector(
    (state) => state.getAllInterviewsReducer.interviews
  );
  const loading = useSelector((state) => state.getAllInterviewsReducer.loading);

  const dispatch = useDispatch();
  const date = moment().format("dddd, MMMM DD, YYYY");

  useEffect(() => {
    dispatch(getAllInterviews());
  }, []);

  return loading ? (
    <Loader />
  ) : interviews.length === 0 ? (
    // <Loader />
    <div className="interviews-page-main-div">
      <div>
        <div className="int-list-mainhead"> Interviews</div>
        <div className="int-list-date">{date}</div>
      </div>
      <div className="int-list-center">
        <img
          src={EmptyInterviews}
          alt="EmptyInterviewpic"
          className="nointerviewdataimage"
        ></img>
        <div className="nointerviewdatatext">No interviews for today</div>
      </div>
      <div className="int-list-divider"></div>
    </div>
  ) : (
    <div style={{'background-color' : '#fff'}} >
      <div>
        <div className="int-list-mainhead"> Interviews</div>
        <div className="int-list-date">{date}</div>
      </div>

      <div className="int-list-divider"></div>
      <div className="all-interviews-containerbox-parent">
      <Row className="all-interviews-containerbox" >
        {interviews.map((item, index) => {
          return (
            <Col
              className={"interview-cards-container"} key={index}
>
              <InterviewCard
                {...item}
              
              />
            </Col>
          );
        })}
          </Row>
          </div>
         </div> 
   
  );
};

export default InterviewListing;
